
export const getManageHome = () => {
  if (isDaumBlogDomain()) {
    var uri = window.location.pathname;
    return "/" + getName() + "/manage";
  }
  return "/manage";
}

export const getName = () => {
  if (isDaumBlogDomain()) {
    var uri = window.location.pathname;
    return uri.split('/')[1]
  }
  // else {
  //   var url = window.location.hostname;
  //   return url.split('.')[0];
  // }
  return '';
}

export const addPrefix = (str = '') => {
  if (isDaumBlogDomain()) {
    return '/' + getName() + str;
  }
	return str;
}

export const isDaumBlogDomain = () => {
  return (window.location.hostname).substr(-9) == '.daum.net';
}
